import React from 'react';
import DrawOutlinedIcon from '@mui/icons-material/DrawOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import styles from './ResourceFormPopup.module.css';

const ACCEPT = '.png,.jpg,.jpeg';

/** Botão que abre a escolha de arquivo (o input fica escondido dentro do label). */
function PickFileButton({ inputRef, onChange, label, primary }) {
    return (
        <label className={`${styles.fileButton} ${primary ? styles.fileButtonPrimary : ''}`}>
            <ImageOutlinedIcon fontSize="small" />
            {label}
            <input ref={inputRef} type="file" accept={ACCEPT} onChange={onChange} className={styles.hiddenInput} />
        </label>
    );
}

/**
 * Assinatura usada nos documentos da agenda: mostra a atual (trocar ou remover),
 * a prévia do arquivo escolhido (manter a atual) ou o espaço para carregar a primeira.
 */
function SignatureField({
    signatureFilePath, currentSrc, selectedFile, selectedFilePreview, inputFileRef,
    onFileChange, onClearFile, onRemoveSignature,
}) {
    if (signatureFilePath && !selectedFile) {
        return (
            <div className={styles.signatureBox}>
                <img src={currentSrc} alt="Assinatura atual" className={styles.signatureImage} />
                <div className={styles.signatureActions}>
                    <PickFileButton inputRef={inputFileRef} onChange={onFileChange} label="Trocar" />
                    <button type="button" className={styles.dangerButton} onClick={onRemoveSignature}>
                        <DeleteOutlineIcon fontSize="small" />
                        Remover
                    </button>
                </div>
            </div>
        );
    }

    if (selectedFile) {
        return (
            <div className={styles.signatureBox}>
                {selectedFilePreview && (
                    <img src={selectedFilePreview} alt="Prévia da assinatura" className={styles.signatureImage} />
                )}
                <div className={styles.signatureMeta}>
                    <span className={styles.fileName}>{selectedFile.name}</span>
                    <span className={styles.hint}>Vai ser salva ao confirmar.</span>
                </div>
                {/* Só o rodapé do popup se chama Cancelar: aqui desfaz a escolha do arquivo */}
                <button type="button" className={styles.ghostButton} onClick={onClearFile}>
                    <CloseRoundedIcon fontSize="small" />
                    {signatureFilePath ? 'Manter a atual' : 'Desfazer'}
                </button>
            </div>
        );
    }

    return (
        <div className={`${styles.signatureBox} ${styles.signatureEmpty}`}>
            <span className={styles.blockIcon}><DrawOutlinedIcon fontSize="small" /></span>
            <div className={styles.signatureMeta}>
                <span className={styles.blockTitle}>Nenhuma assinatura</span>
                <span className={styles.hint}>PNG ou JPG, de preferência com fundo transparente.</span>
            </div>
            <PickFileButton inputRef={inputFileRef} onChange={onFileChange} label="Carregar" primary />
        </div>
    );
}

export default SignatureField;
